import React from "react";

const EmptyRowComponent = ({
  text = "Package not available on the specified date. Please change the travel date.",
}) => {
  return (
    <div className="row">
      <div className="col-md-12 col-sm-12 col-lg-12">
        <div className="justify-content-center">
          <div className="images-part">
            <img src={"images/noHotel.png"} style={{ margin: "0 auto" }} />
          </div>
          <div className="soldoutcontent">
            <h3>We're sorry</h3>
            <p>{text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyRowComponent;
